<template>
  <div>
    <mdb-parallax
      src="/home-background.jpg"
      height="full"
      factor="2">
      <mdb-mask overlay="blue-slight" flexCenter>
        <mdb-row class="mb-5 pb-5 text-center white-text">
          <mdb-col md="12" xl="12" class="mx-auto">
            <h1 class="pentagon-title font-weight-bold animated fadeInDown">
              {{ $t('home.title') }}
            </h1>
            <h5 class="pentagon-description-title font-weight-bold pt-md-5 pt-sm-2 pt-5 pb-md-5 pb-sm-3 pb-5 animated fadeInDown">
              {{ $t('home.motto') }}
            </h5>
          </mdb-col>
        </mdb-row>
      </mdb-mask>
    </mdb-parallax>
    <main>
      <mdb-container>
        <!--Grid row-->
        <mdb-row class="py-5" center>
          <!--Grid column-->
          <mdb-col md="8" sm="12">
            <h1 class="pentagon-title font-weight-bold text-center">{{ $t('home.membership_heading') }}</h1>
<!--            <p>-->
<!--              Is jouw eindexamen reis je door de neus geboord door Corona? Het feit dat je vakantie hebt sinds mei nutteloos omdat je toch niet uit kon gaan?-->
<!--            </p>-->
<!--            <p>-->
<!--              Erachter gekomen dat de studievereniging niet genoeg sociale activiteiten heeft nu het fysieke studeren wegvalt?-->
<!--            </p>-->
<!--            <p>-->
<!--              De komende 5 jaar heb je de kans om dit allemaal in te halen! Hoe dan, hoor ik je al denken. Door je in te schrijven bij ons dispuut!-->
<!--            </p>-->
            <p>
              {{ $t('home.introduction_one') }}
            </p>
            <p>
              {{ $t('home.introduction_two') }}
            </p>
            <p>
              {{ $t('home.introduction_three') }}
            </p>
          </mdb-col>

          <mdb-col md="6" class="text-center">
            <mdb-btn tag="a" floating color="pink" class="accent-2" :aria-label="$t('social.instagram')" @click="navigateTo('https://www.instagram.com/pentagon.amsterdam/')">
              <mdb-icon fab icon="instagram" size="2x" class="pointer" />
            </mdb-btn>
          </mdb-col>

          <mdb-col md="6" class="text-center">
            <mdb-btn tag="a" floating color="indigo" class="accent-2" :aria-label="$t('social.facebook')" @click="navigateTo('https://www.facebook.com/pentagonamsterdam')">
              <mdb-icon fab icon="facebook-f" size="2x" class="facebook-text pointer" />
            </mdb-btn>
          </mdb-col>
          <!--Grid column-->
        </mdb-row>
        <!--Grid row-->

<!--        &lt;!&ndash;Grid row&ndash;&gt;-->
<!--        <mdb-row class="py-5">-->
<!--          &lt;!&ndash;Grid column&ndash;&gt;-->
<!--          <mdb-col md="12">-->
<!--            <p>-->
<!--              Het Amsterdamsch Heerendispuut P.E.N.T.A.G.O.N. is gelieerd aan studentenvereniging Nomen Non Magnum Est, kortweg NoNoMes, te Amsterdam. P.E.N.T.A.G.O.N. is opgericht in 1989.-->
<!--            </p>-->
<!--            <p>-->
<!--              Een vast patroon van tradities en gedeelde waarden, tezamen met het jaarlijks verwelkomen van nieuwe persoonlijkheden heeft ertoe geleid dat P.E.N.T.A.G.O.N. zich kan kenmerken met een uniek en divers actief ledenbestand. Het grote aantal actieve reünisten laat zien dat een dispuut voor een P.E.N.T.A.G.O.N-ees meer betekent dan een kortstondig feestmoment.-->
<!--            </p>-->
<!--            <p>-->
<!--              Daar waar het lijkt alsof het Amsterdamse studentenleven elk jaar curieuzere vormen kan aannemen, geldt de dinsdagavond voor de leden als emotionele houvast in de week. Na de vaste borrel in stamkroeg de Heffer, wordt deze avond tot in de vroege uurtjes voortgezet in de sociëteit De Heilige Zeug. Door de jaren heen heeft het dispuut een vast repertoire van Amsterdamse kroegen en cafés eigen gemaakt, waar de leden op de andere doordeweekse avonden en in het weekend te vinden zijn.-->
<!--            </p>-->
<!--            <p>-->
<!--              Vaste activiteiten als diners, gala's, weekenden weg, hockeytoernooien en vakanties zorgen ervoor dat een lidmaatschap bij P.E.N.T.A.G.O.N. garant staat voor levenslange vriendschappen en onvergetelijke herinneringen aan een prachtig Amsterdams studentenleven.-->
<!--            </p>-->
<!--          </mdb-col>-->
<!--          &lt;!&ndash;Grid column&ndash;&gt;-->
<!--        </mdb-row>-->
<!--        &lt;!&ndash;Grid row&ndash;&gt;-->
      </mdb-container>
    </main>
  </div>
</template>

<script>
import {
  mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem, mdbInput, mdbContainer, mdbParallax, mdbMask, mdbRow, mdbCol, mdbBtn, mdbIcon,
} from 'mdbvue';

export default {
  name: 'home',
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbInput,
    mdbContainer,
    mdbParallax,
    mdbMask,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbIcon,
  },
  created() {
    this.$store.commit('TOGGLE_ON_NAVBAR_TRANSPARENT');
  },
  methods: {
    navigateTo(url) {
      window.open(url);
    },
  },
};
</script>

<style>
.pentagon-title {
  color: gold;

  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.pentagon-description-title {
  font-style: italic;
}

@media (max-width: 576px) {
  .pentagon-title {
    font-size: 2.5rem;
    font-weight: 300;
    line-height: 1.2;
  }

  .pentagon-description-title {
    font-size: .7rem;
    font-weight: 300;
    line-height: 1.2;
  }
}

@media (max-width: 326px) {
  .pentagon-title {
    font-size: 1.5rem;
    font-weight: 300;
    line-height: 1.2;
  }

  .pentagon-description-title {
    font-size: .6rem;
    font-weight: 300;
    line-height: 1.2;
  }
}
</style>
